<template>
    <div>
        <van-nav-bar :title="title" :left-text="$t('system.back')" left-arrow @click-left="onClickLeft" class="Header" :right-text="$t('system.lang')"  @click-right="show = true">
            <slot></slot>
        </van-nav-bar>
        <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
    </div>
</template>

<script>
    export default {
        name: "Header",
        data(){
          return{
              show:false,
              actions: [{ name: '简体中文' }, { name: 'English' }, { name: 'Deutsch' }],
          }
        },
        props:['title'],
        computed:{
            // classArr:{
            //     get(){
            //         if(this.$route.name=='Recommend'||this.$route.name=='Information'){
            //
            //             return this.classArr = ["Header"];
            //         }else{
            //             return this.classArr = [];
            //         }
            //     },
            //     set(val){
            //
            //     }
            // }

        },
        mounted(){

        },
        methods: {
            onClickLeft() {
                this.$router.back();
            },
            onSelect(item) {
                // 默认情况下点击选项时不会自动收起
                // 可以通过 close-on-click-action 属性开启自动收起
                this.$nextTick(function () {
                    this.show = false;
                    this.$toast(item.name);
                    switch (item.name) {
                        case '简体中文':
                            window.localStorage.setItem('lang','cn');
                            this.$i18n.locale = 'cn';
                            break;
                        case 'English':
                            window.localStorage.setItem('lang','en');
                            this.$i18n.locale = 'en';
                            break;
                        case 'Deutsch':
                            window.localStorage.setItem('lang','de');
                            this.$i18n.locale = 'de';
                            break;
                        default:
                            window.localStorage.setItem('lang','cn');
                            break;
                    }
                })

            }
        },
        // watch:{
        //     classArr:{
        //         header(nval){
        //             if(this.$route.name=='Recommend'||this.$route.name=='Information'){
        //
        //                 this.classArr = ["Header"];
        //             }
        //         }
        //     }
        // }
    }
</script>

<style scoped >
    .Header{
        background: #ED4E39;
    }
    /deep/ .van-ellipsis {
        color: #fff;
    }

    /deep/  .van-nav-bar .van-icon {
        color: #fff;
    }

    /deep/ .van-nav-bar__text {
        color: #fff;
    }

</style>
